module.exports = __webpack_public_path__ + "img/partner_supplier_channel2.aa2d6af7.png";